import { render, staticRenderFns } from "./RenewalsView.vue?vue&type=template&id=4f2e905d&scoped=true&"
import script from "./RenewalsView.vue?vue&type=script&lang=js&"
export * from "./RenewalsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2e905d",
  null
  
)

export default component.exports